import { gql } from '@apollo/client';
import Fragments from './fragments';

export const SCORING_CATEGORY_UPDATED = gql`
  subscription scoringCategoryUpdated {
    scoringCategoryUpdated {
      scoringCategory {
        ...scoringCategoryItem
      }
    }
  }
  ${Fragments.scoringCategoryItem}
`;

export const SCORING_CATEGORY_DETAIL_UPDATED = gql`
  subscription scoringCategoryDetailUpdated {
    scoringCategoryDetailUpdated {
      scoringDetail {
        ...scoringCategoryDetailItem
      }
    }
  }
  ${Fragments.scoringCategoryDetailItem}
`;

export const SCORING_CATEGORY_DETAIL_DELETED = gql`
  subscription scoringCategoryDetailDeleted {
    scoringCategoryDetailDeleted {
      scoringId
      scoringDetailId
    }
  }
`;
